import clsx from "clsx";

import { Button } from "react-migration/components/Button/Button";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export const SummaryCollapse = ({
  isExpanded,
  setIsExpanded,
}: {
  isExpanded: boolean;
  setIsExpanded: (v: boolean) => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        data-testid="fade-over-text"
        className={clsx(
          "w-full absolute top-0 pointer-events-none",
          "bg-linear-to-b from-transparent to-white transition-opacity ease-out duration-1000",
          isExpanded ? "opacity-0 h-60" : "opacity-100 h-36"
        )}
      />
      <div
        data-testid="collapse-summary-wrapper"
        className="flex flex-col items-center justify-center w-full p-2 font-medium neutral-900"
      >
        <Button
          data-testid="collapse-summary-button"
          variant="ghost"
          tailIcon={isExpanded ? "lt-arrow-up-line" : "lt-arrow-down-line"}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? t("planning.ai.collapse") : t("planning.ai.show")}
        </Button>
      </div>
    </>
  );
};
